import React from "react";
import styled from "styled-components";

import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";

// Components
import FullButton from "../Buttons/FullButton";
// Assets
import HeaderImage from "../../assets/img/custom/landing_img_0.png";

export default function Header() {
  let navigate = useNavigate();

  return (
    <Wrapper id="home" className="container flexSpaceCenter">
      <LeftSide className="flexCenter">
        <Fade direction="left" triggerOnce={true}>
          <div>
            <h1 className="regular font60">  Potenciá la Gestión de tus <span className="extraBold wc-secondary">Clases y Talleres</span></h1>
            <HeaderP className="font20 regular">
              <hr />
              Creá tu propio <span className="extraBold wc-secondary">espacio online</span> en minutos para organizar clases y alumnos.
              <br />
              <br />
              Administrá <span className="extraBold wc-secondary">reservas, cancelaciones y pagos</span> de forma eficiente y profesional.
            </HeaderP>
            <BtnWrapper>
              <FullButton title="Creá tu espacio ahora" action={() => navigate("/home/create")} />
            </BtnWrapper>
          </div>
        </Fade>
      </LeftSide>
      <RightSide>
        <Fade direction="right" triggerOnce={true}>
          <ImageWrapper>
            <Img src={HeaderImage} alt="office" style={{ zIndex: 9 }} />
          </ImageWrapper>
        </Fade>
      </RightSide>
    </Wrapper>
  );
}


const Wrapper = styled.section`
  padding-top: 100px;
  width: 100%;
  min-height: 820px;
  display: flex;
  align-items: center;
  
  @media (max-width: 960px) {
    flex-direction: column;
    padding-top: 120px;
    min-height: auto;
  }
  
  @media (max-width: 480px) {
    padding-top: 100px;
  }
`;

const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 40px 0;
    text-align: center;
    padding: 0 20px;
  }
  
  @media (max-width: 480px) {
    margin: 30px 0;
    padding: 0 10px;
  }
`;

const RightSide = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin-top: 20px;
    padding: 0 20px;
  }
  
  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;
const HeaderP = styled.div`
  max-width: 470px;
  padding: 20px 0 40px 0;
  line-height: 1.6rem;
  
  @media (max-width: 960px) {
    padding: 20px 0 40px 0;
    text-align: center;
    max-width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 15px 0 30px 0;
    line-height: 1.5rem;
  }
`;

const BtnWrapper = styled.div`
  max-width: 220px;
  
  @media (max-width: 960px) {
    margin: 0 auto;
    max-width: 250px;
  }
  
  @media (max-width: 480px) {
    max-width: 100%;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`;

const Img = styled.img`
  width: 100%;
  max-width: 500px;
  height: auto;
  background: transparent;
  
  @media (max-width: 960px) {
    max-width: 400px;
  }
  
  @media (max-width: 480px) {
    max-width: 100%;
  }
`;



